import {
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import { DeleteOutlined, EditOutlined } from "@material-ui/icons";
import { getDatabase, ref, remove } from "firebase/database";
import React from "react";
import { BeatLoader } from "react-spinners";
import Editjob from "./EditJob";
const Job = ({ job }) => {
  const [loading, setLoading] = React.useState(false);
  const [balance, setBalance] = React.useState();
  const [name, setName] = React.useState();
  const [show, setShow] = React.useState(false);
  const [showEdit, setShowEdit] = React.useState(false);
  const deleteJob = async () => {
    if (window.confirm("Are you Want To Sure Delete This Job")) {
      const db = getDatabase();
      remove(ref(db, `Jobs/${job.jobId}`))
        .then((res) => {
          console.log("Job Deleted Successful");
        })
        .catch((err) => {});
    } else {
    }
  };

  //   function updateJob(memberType) {
  //     const db = getDatabase();
  //     setLoading(true);
  //     update(ref(db, `Users/${user.userId}`), {
  //       name,
  //       balance: parseFloat(balance),
  //     })
  //       .then((res) => {
  //         setLoading(false);
  //         setShow(false);
  //       })
  //       .catch((err) => {
  //         setLoading(false);
  //       });
  //   }

  return (
    <div>
      <Card elevation={1}>
        <CardHeader
          //   avatar={<Person aria-label="recipe">R</Person>}
          action={
            <IconButton aria-label="settings">
              <DeleteOutlined onClick={() => deleteJob()} />
              <EditOutlined
                onClick={() => setShowEdit(!showEdit)}
                style={{ marginLeft: "10px" }}
              />
            </IconButton>
          }
          title={job.title}
          subheader={job.location}
        />
        <CardContent>
          <Typography variant="h5" color="textSecondary">
            Salary : {job?.salary}
          </Typography>
          <Typography variant="h6" color="textSecondary">
            Skill : {job?.skill}
          </Typography>
          <Typography variant="h6" color="textSecondary">
            Delay Time :<span style={{ color: "red" }}>{job?.delayTime}</span>
          </Typography>{" "}
          <Typography variant="h6" color="textSecondary">
            Job Price :<span style={{ color: "green" }}>{job?.jobPrice}</span>
          </Typography>
        </CardContent>

        {show && (
          <div style={{ marginLeft: "25px" }}>
            <TextField
              value={balance}
              onChange={(e) => setBalance(e.target.value)}
              label="Balance"
              variant="outlined"
              color="secondary"
              required
              type="number"
            />
            <br />
            <br />
            <br />
            <TextField
              value={name}
              onChange={(e) => setName(e.target.value)}
              label="Name"
              variant="outlined"
              color="secondary"
              required
              type="text"
            />
            <br />
            <br />
            {loading ? (
              <BeatLoader loading={loading} />
            ) : (
              <Button
                style={{ marginBottom: "10px" }}
                color="secondary"
                variant="outlined"
                type="submit"
                endIcon={<EditOutlined />}
              >
                Update
              </Button>
            )}
          </div>
        )}
        {showEdit && (
          <Editjob
            open={showEdit}
            handleClose={() => setShowEdit(false)}
            job={job}
          />
        )}
      </Card>
    </div>
  );
};

export default Job;
